var _radialGradient, _path, _radialGradient2, _path2, _radialGradient3, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMs365(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "yRNsYj0k48m_5059Aqtv_a",
    cx: -1207.054,
    cy: 544.406,
    r: 0.939,
    gradientTransform: "matrix(-11.7002 31.247 54.5012 20.4075 -43776.117 26617.47)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.064,
    stopColor: "#bf8af6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533,
    stopColor: "#3079d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11408c"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#yRNsYj0k48m_5059Aqtv_a)",
    d: "M20.084,3.026L19.86,3.162c-0.357,0.216-0.694,0.458-1.008,0.722l0.648-0.456H25L26,11l-5,5 l-5,3.475v4.007c0,2.799,1.463,5.394,3.857,6.844l5.264,3.186L14,40h-2.145l-3.998-2.42C5.463,36.131,4,33.535,4,30.736V17.261 c0-2.8,1.464-5.396,3.86-6.845l12-7.259C19.934,3.112,20.009,3.068,20.084,3.026z"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "yRNsYj0k48m_5059Aqtv_b",
    cx: -1152.461,
    cy: 523.628,
    r: 1,
    gradientTransform: "matrix(30.7198 -4.5183 -2.9847 -20.2925 36976.637 5454.876)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.211,
    stopColor: "#bf8af6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#591c96"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#yRNsYj0k48m_5059Aqtv_b)",
    d: "M32,19v4.48c0,2.799-1.463,5.394-3.857,6.844l-12,7.264c-2.455,1.486-5.509,1.54-8.007,0.161 l11.722,7.095c2.547,1.542,5.739,1.542,8.285,0l12-7.264C42.537,36.131,44,33.535,44,30.736V27.5L43,26L32,19z"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "yRNsYj0k48m_5059Aqtv_c",
    cx: -1236.079,
    cy: 516.112,
    r: 1.19,
    gradientTransform: "matrix(-24.1583 -6.1256 -10.3118 40.6682 -24498.48 -28534.523)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.059,
    stopColor: "#50e6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#3079d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11408c"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#yRNsYj0k48m_5059Aqtv_c)",
    d: "M40.14,10.415l-12-7.259c-2.467-1.492-5.538-1.538-8.043-0.139L19.86,3.162 C17.464,4.611,16,7.208,16,10.007v9.484l3.86-2.335c2.546-1.54,5.735-1.54,8.281,0l12,7.259c2.321,1.404,3.767,3.884,3.855,6.583 C43.999,30.911,44,30.824,44,30.736V17.26C44,14.461,42.536,11.864,40.14,10.415z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMs365);
export default __webpack_public_path__ + "static/media/ms365.fdb56827e6802d917b478e15f63ad2f0.svg";
export { ForwardRef as ReactComponent };